var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"speech-container"}},[_c('br'),_c('label',{staticClass:"label"},[_vm._v("Your spoken text: "+_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }